import React from 'react';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';
import Heading from 'src/components/Heading';
import NewBadge from 'src/components/NewBadge/NewBadge';
import Card from 'src/components/Card';
import LoadState from 'src/components/LoadState/LoadState';
import Empty from 'src/components/Empty';
import Callout from 'src/components/InformationCallout/Callout';
import { variables } from 'src/Tenants';
import StrataManagerUnitCard from 'src/pages/StrataManagerSuites/components/StrataManagerUnitCard';
import StrataManagerSuitesSkeleton from 'src/pages/StrataManagerSuites/components/StrataManagerSuitesSkeleton';
import {
  useStrataManagerSuitesOrchestrator,
  UseStrataManagerSuitesOrchestratorReturn,
} from 'src/pages/StrataManagerSuites/CustomHooks/useStrataManagerSuitesOrchestrator';
import {
  IStrataManagerPropertyGroup,
  IStrataManagerUnit,
} from 'src/pages/StrataManagerSuites/types';
import './strata-manager-suites.scss';

const StrataManagerSuites = () => {
  const {
    propertyGroups,
    isLoading,
    error,
    unitDetailPath,
  }: UseStrataManagerSuitesOrchestratorReturn =
    useStrataManagerSuitesOrchestrator();

  return (
    <WithNavigation
      title="Inventory and Areas"
      top={
        <Heading
          headline="Inventory and Areas Across Properties"
          headlineAction={<NewBadge spaced />}
        />
      }
      bottom={
        <div className="strata-manager-suites">
          <div className="strata-manager-suites-intro">
            <Callout
              variant="info"
              title={`Inventory or Areas you manage as a ${variables.strataManager}`}
              subtitle={`A property developer or admin has added you to the below properties and related inventory and areas. For each one you can view its rooms & assets, create service requests, and send messages.`}
            />
          </div>
          {isLoading ? (
            // Skeleton renders in normal flow (not LoadState's centered fill) so it
            // matches the loaded content's full-width, top-aligned grid layout.
            <StrataManagerSuitesSkeleton />
          ) : (
            <LoadState
              isLoading={false}
              isEmpty={propertyGroups.length === 0}
              error={error}
              emptyNode={
                <Empty
                  headline="No units assigned"
                  strapline="You don't have any units assigned to you yet."
                  searchIsActive={''}
                  image={''}
                />
              }
            >
              {propertyGroups.map((group: IStrataManagerPropertyGroup) => (
                <div
                  key={group.propertyId}
                  className="strata-manager-suites-group"
                >
                  <Card
                    title={group.propertyName}
                    body={
                      <div className="strata-manager-suites-grid">
                        {group.units.map((unit: IStrataManagerUnit) => (
                          <StrataManagerUnitCard
                            key={unit.unitId}
                            unit={unit}
                            to={unitDetailPath(group.propertyId, unit.unitId)}
                            propertyName={group.propertyName}
                          />
                        ))}
                      </div>
                    }
                  />
                </div>
              ))}
            </LoadState>
          )}
        </div>
      }
    />
  );
};

export default StrataManagerSuites;